import { formatCivilDateToPtBR, parseCivilDate } from '../civil-date';
import type { DateInputProperties, FormElement } from '../../model/form.types';
import type { FieldDefinition, FieldValue, ValidationIssue } from '../../model/types';
import { isEmptyValue, requiredIssue, singleColumn, stringShapeIssue, typeIssue } from './shared';

type DateInputElement = FormElement & { properties: DateInputProperties };

export const INVALID_DATE_MESSAGE = 'Data inválida.';

// The blob stores a civil date (`YYYY-MM-DD`, DATE_CONVENTIONS.md); a Date object or an ISO
// instant would drift by a day across time zones, so only the strict string shape is a value.
function isCivilDate(value: FieldValue): value is string {
  return typeof value === 'string' && parseCivilDate(value) !== null;
}

function shapeIssue(element: DateInputElement, value: FieldValue): ValidationIssue | null {
  const stringShape = stringShapeIssue(element, value);
  if (stringShape) return stringShape;
  if (isEmptyValue(value) || isCivilDate(value)) return null;
  return typeIssue(element, INVALID_DATE_MESSAGE);
}

export const dateInputDefinition: FieldDefinition<DateInputElement> = {
  kind: 'field',
  type: 'DATE_INPUT',
  emptyValue: () => '',
  control: (element) => ({ kind: 'date', placeholder: element.properties.placeholder }),
  shapeIssue,
  validate: (element, value) => {
    const shape = shapeIssue(element, value);
    if (shape) return [shape];
    if (isEmptyValue(value) && element.properties.required) return [requiredIssue(element)];
    return [];
  },
  columns: singleColumn,
  cells: (_element, value) => [isCivilDate(value) ? formatCivilDateToPtBR(value) : ''],
  triggerMatches: () => false,
};
